export const PagoPendiente =[
    {
      Header: "No. de Guía",
      accessor: "guiahija"
    },
    {
        Header: "Proveedor",
        accessor: "Proveedor"
      },
    {
      Header: "Casilla",
      accessor: "casilla"
    },
    {
       Header: "Descripcion",
       accessor: "descprod"
    },
    {
      Header: "Fecha Recepción MIAMI/ESPAÑA",
      accessor: "FechaIngMiami"
   },
    {
        Header: "Valor FOB (USD)",
        accessor: "valfob"
    },
    {
      Header: "Costo Trasporte (Pesos)",
      accessor: "flete"
    },
    {
      Header: "Impuesto Aduana (Pesos)",
      accessor: "ImpuestoAduana"
    },
    {
      Header: "Manejo de carga (Pesos)",
      accessor: "OtrosGastos"
    },
    
    {
      Header: "Seguro (Pesos)",
      accessor: "seguro"
    },
    {
      Header: "Almacenaje (Pesos)",
      accessor: "Almacenaje"
    },
    {
      Header: "Descuentos (Pesos)",
      accessor: "descuento"
    },
    {
        Header: "Total (Pesos)",
        accessor: "Total"
      }
  ];


  export const PagoPendienteInicial={
    guia:"",
    Tienda:"",
    casilla:"",
    Descripcion:"",
    Valor_Fob:"",
    flete:"",
    ImpuestoAduana:"",
    OtrosGastos:"",
    seguro:"",
    Almacenaje:"",
    Total:0,
    FechaIngMiami:""
  }